/**
 * Where a saved record came from.
 *
 * Deliberately dependency-free: museumCanvas.js imports this and is itself kept
 * free of app and three.js imports so it can be loaded straight into a plain
 * ESM page for layout previews.
 */

// A record's `source` is 'roam' in older/legacy data but 'inkquote_roam' in
// current InkQuote-backed data. Every "is this from Roam?" check should go
// through this predicate instead of comparing against a single string, or it
// silently misses the live data.
export function isRoamSource(source) {
  return source === 'roam' || source === 'inkquote_roam';
}
